// Bonst: play a product card's hover video while the pointer is over the card.
(function () {
  if (window.__bonstCardVideo) return;
  window.__bonstCardVideo = true;
  const canHover = window.matchMedia('(hover: hover)').matches;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!canHover || reduceMotion) return;

  const videoIn = (el) => el && el.querySelector && el.querySelector('video.card__hover-video');

  document.addEventListener(
    'pointerenter',
    (e) => {
      if (!e.target.classList || !e.target.classList.contains('card-wrapper')) return;
      const v = videoIn(e.target);
      if (v) {
        v.muted = true;
        v.play().catch(() => {});
      }
    },
    true
  );
  document.addEventListener(
    'pointerleave',
    (e) => {
      if (!e.target.classList || !e.target.classList.contains('card-wrapper')) return;
      const v = videoIn(e.target);
      if (v) {
        v.pause();
        v.currentTime = 0;
      }
    },
    true
  );
})();